<template>
    <i v-if="inFavorites" class="icon-favourites-full"></i>
</template>

<script>
import Request from '@Core/xhr'

export default {

    data() {
        return {
            inFavorites: false
        }
    },

    created() {
        App.dispatcher.listen('favorites.loaded', response => {
            this.inFavorites = response.result.length;            
        })

        new Request().get('/favorites/get').then((response) => {
            this.inFavorites = response.result.length;
        })
    }

}
</script>
